import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MaterialCssVarsService } from 'angular-material-css-vars';
import { Theme } from '../models/colors';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelfThemerService {

  constructor(
    @Inject(DOCUMENT) private _document: any,
    public materialCssVarsService: MaterialCssVarsService ) { }

    public imgBase: string;
    public customThemes: Array<Theme>;

    public themeName: string;
    public theme: Theme;
    public themeChanged: BehaviorSubject<Theme>= new BehaviorSubject<Theme>(new Theme);
    setTheme(theme: string ){
      this.themeName = theme;
      this.theme = this.customThemes.find(val => val.value === theme);
      if(!this.theme){
        console.log('Theme does not exist. Reverting to default');
        this.theme = this.customThemes[0];
      }
      this.materialCssVarsService.setDarkTheme(this.theme.darkMode);
      this.materialCssVarsService.setPrimaryColor(this.theme.primary);
      this.materialCssVarsService.setAccentColor(this.theme.accent);
      this.materialCssVarsService.setAutoContrastEnabled(true);
      for(let themeItem of this.customThemes){
        if(this._document.body.classList.contains(themeItem.value)){
          this._document.body.classList.remove(themeItem.value);
        }
      }
      this._document.body.classList.add(this.theme.value);
      if(this.theme.customValues){
        for (const key in this.theme.customValues) {
          this._document.body.style.setProperty(key, this.theme.customValues[key]);
        }
      }
      this.themeChanged.next(this.theme);
      this.storeTheme(this.theme.value);
    }
    configure(imageBase: string,customThemes: Array<Theme>, theme: string = "lastTheme"){
      if(theme == "lastTheme"){
        theme = this.retrieveTheme();
        if(!theme){
          theme = customThemes[0].value;
        }
      }
      else if (theme == "default"){
        theme = customThemes[0].value;
      }
      this.customThemes = customThemes;
      this.setTheme(theme);
      this.imgBase = imageBase;
    }
    validate(){

    }
    private storeTheme(theme: string){
      localStorage.setItem("wg-theme", theme);
    }
    private retrieveTheme(): string{
      return localStorage.getItem("wg-theme");
    }
}
